import React, { useState } from "react";
import NavBar from "../../communs/NavBar";
import HeroSectionDetailsProject from "../layout-details-project/HeroSectionDetailsProject";
import headerMobileBg from "../../../assets/images/heroMobile3.jpg";
import headerBg from "../../../assets/background/headebg.png";
import { Col, Row } from "antd";
import FooterSection from "../../../components/sections/FooterSection";
import CardDetailsPalm from "../../../components/card-palm/CardDetailsPalm";
import { RootState } from "../../../apis/store";
import { useSelector } from "react-redux";
import DonationPalmCard from "./DonationPalmCard";
import Loader from "../../../biblio/Loader/Loader";
import Seo from "../../../components/seo/Seo";

const LayoutDetailsPalmEdowment = () => {

  const { palms } = useSelector((state: RootState) => state.palm);
  const [loading] = useState<boolean>(true);
/*
  useEffect(() => {
    dispatch(getPalms());
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [dispatch]);
*/
  if (loading) return <Loader />;

  return (
    <div className="takaful--layout-details">
      <Seo
        title="وقف النخيل"
        description={palms?.address}
        image={palms?.image_banner_ids?.[0]}
      />
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="الرئيسية"
        subTitle="تفاصيل وقف النخيل"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
      />
      <Row dir="rtl" justify={"space-between"}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Col
          xxl={14}
          xl={14}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <CardDetailsPalm palms={palms} />
        </Col>
        <Col
          xxl={7}
          xl={7}
          lg={12}
          md={12}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
          className="takaful--donation-card-container"
        >
          <DonationPalmCard palms={palms} />
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
      </Row>

      <FooterSection />
    </div>
  );
};

export default LayoutDetailsPalmEdowment;
